import AbstractDeleteTask from '@vertical-plus/vue-js-api-platform/dist/model/task/abstract-delete-task';

export default class DeleteTimesheetTask extends AbstractDeleteTask
{
    public timesheetId!: number;

    public async run(): Promise<void>
    {
        const response = await this.execute();

        if (response.status === this.successCode)
        {
            return;
        }

        this.handleErrorResponse(response.status);
    }

    protected get url(): string
    {
        return `/timesheets/${ this.timesheetId }`;
    }
}